import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the DbclistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-dbclist',
  templateUrl: 'dbclist.html',
})
export class DbclistPage {
    loginId: string;
	email: string;
    api_key: string;
    version: string;

    idx: string;
	list: any = [];
    
	coin_unit: string;	
	unit: string;
	token_unit: string;
    
    balance: any = [];

	texts: any = [];
    language : string;

    isButton : boolean = true;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
        // private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {

	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "apply");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.unit = localStorage.getItem("unit");
		this.token_unit = localStorage.getItem("token_unit");

        this._get_texts();

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).dbclist;
	}

	_init() {
		this.list = [];
		
        let url = "coin/dbc";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.balance = res.balance;
                // this.idx = res.idx;
 
                if (res.list != undefined) {  
                    if (res.idx == undefined || res.idx == null || res.idx == '') {
                        this.list = res.list;
                    } else {
                        let list = this.list.concat(res.list);
                        this.list = list;
                    }
                }

			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: err.message,
				buttons: ['OK']
			});
			alert.present();
		});
	}
}



// WEBPACK FOOTER //
// ./src/pages/dbclist/dbclist.ts